import React, { Component, PropTypes } from 'react';
import { Deck } from 'spectacle-ppa';

import balloonSlide from './baseSlides/balloonSlide';

import saraGiggle from './images/characters/sara_giggle.png';

import MarkdownScript from 'helpers/markdownScript';
import levelCompleted from './levelCompleted.md';

const md = new MarkdownScript(levelCompleted);

export default class extends Component {

  static contextTypes = {
    regionData: PropTypes.object.isRequired
  };

  render () {
    const { regionData } = this.context;

    return (

      <Deck transition={['slide']}
            transitionDuration={800}
            progress="bar">

        {balloonSlide({
          id: 'welcome-back',
          characterSide: 'right',
          characterImage: saraGiggle,
          notes: md.getSubSectionAsHtml('Level Completed', 'Notes', false, regionData),
          html: md.getSubSectionAsHtml('Level Completed', 'Content', false, regionData),
          bgColor: '#37b34a'
        })}

      </Deck>
    );
  }

}



// WEBPACK FOOTER //
// ./programs/epsPrimaries/levelCompleted.jsx